/* eslint-disable no-use-before-define */
import { I18n } from 'react-redux-i18n';
import _ from 'lodash';
import { LIST_FILTERED } from './types/modulesTypes';
import api from './../../api';

export function getList() {

  return new Promise((resolve) => {

    setTimeout(() => {

      resolve([]);

    }, 1000);
    
  });

}

export const getFilteredMenu = () => (dispatch) => {

  return new Promise((resolve) => {

    setTimeout(() => {

      dispatch({
        type: LIST_FILTERED,
        result: [],
        list: [],
      });

      resolve([]);

    }, 1000);
    
  });

};

function toTree(data, options) {

  options = options || { sortByKey: 'orderPriority' };
  const ID_KEY = options.idKey || 'id';
  const PARENT_KEY = options.parentKey || 'applicationModuleParentId';
  const CHILDREN_KEY = options.childrenKey || 'children';

  let tree = [],
    childrenOf = {};
  let item,
    id,
    parentId;

  for (let i = 0, length = data.length; i < length; i++) {

    item = data[i];
    id = item[ID_KEY];
    parentId = item[PARENT_KEY] || 0;
    // every item may have children
    childrenOf[id] = childrenOf[id] || [];
    // init its children
    item[CHILDREN_KEY] = childrenOf[id];
    if (parentId != 0 && parentId != '00000000-0000-0000-0000-000000000000') {

      // init its parent's children object
      childrenOf[parentId] = childrenOf[parentId] || [];
      // push it into its parent's children object
      childrenOf[parentId].push(item);

    } else {

      tree.push(item);

    }

  }

  tree = sortModules(tree, options.sortByKey);

  return tree;

}

function sortModules(modules, sorter) {

  modules = _.sortBy(modules, [item => I18n.t(`menu.${item.moduleName}`), sorter]);

  modules.map((module) => {

    if (module.children)

      module.children = sortModules(module.children);


  });

  return modules;

}



// WEBPACK FOOTER //
// ./src/redux/actions/moduleActions.js